import { Box, BoxProps } from '@dtx-company/shared-components/src'
import { media } from '../../theme/media-queries'
import styled from 'styled-components'

type DisplayType = 'block' | 'none'

export interface ResponsiveBoxProps extends BoxProps {
  mobile: DisplayType
  tablet: DisplayType
  desktop?: DisplayType
}

export const ResponsiveBox = styled(Box)<ResponsiveBoxProps>`
  display: ${props => props.mobile || 'block'};

  ${media.tablet} {
    display: ${props => props.tablet || 'block'};
  }

  ${media.desktop} {
    display: ${props => props.desktop || props.tablet || 'block'};
  }
`
